<template>
  <div class="feed-media">
    <FeedImage
      v-for="(img, index) in imageList"
      :key="index"
      :imgUrl="img"
      :urlList="feed.uriKey"
      :feed="feed"
    />
  </div>
</template>
<script>
import FeedImage from "../feed-image";
export default {
  name: "album-element",
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageList: [],
    };
  },
  beforeMount() {
    this.imageList = [];
  },
  mounted() {
    if (this.feed.uriKey && this.feed.uriKey[0]) {
      this.imageList = this.feed.uriKey.slice(0, 3);
    } else {
      this.imageList = [];
    }
  },
  components: {
    FeedImage,
  },
};
</script>
<style scoped>
.feed-media {
  display: flex;
  margin: 8px 0;
}

.feed-media:empty {
  margin: 4px 0;
}
</style>